import React from 'react'
import { Card, Heading, Text } from '../ui'

/**
 * Props interface for the IntroSection component
 */
export interface IntroSectionProps {
  /** Unique identifier for the section */
  id?: string
  /** CSS class name for custom styling */
  className?: string
}

/**
 * Introduction section component for the About page showcasing Lucas Stufflebeam's
 * personal story and professional background.
 *
 * Features:
 * - Professional bio with first-person narrative
 * - Photo placeholder with accessible fallback
 * - Responsive grid layout
 * - Semantic HTML structure
 */
export const IntroSection: React.FC<IntroSectionProps> = ({
  id,
  className = '',
}) => {
  return (
    <Card
      variant="surface"
      padding="lg"
      className={`intro-section ${className}`}
      role="region"
      aria-labelledby="intro-heading"
      id={id}
    >
      <div className="intro-layout">
        <div className="intro-text">
          <Heading as="h2" size="xl" variant="default" id="intro-heading">
            Hello, I'm Lucas
          </Heading>
          <Text size="base" variant="primary" className="intro-bio">
            I'm a Principal Software Architect with over 15 years of experience
            designing and building systems that handle real-world complexity at
            scale. My journey began in game development, where I learned to
            build systems that must perform flawlessly under intense user loads,
            and has evolved into architecting enterprise platforms that support
            hundreds of thousands of concurrent users across global markets.
          </Text>
          <Text size="base" variant="secondary" className="intro-bio">
            What drives me is the intersection of technical excellence and human
            impact. Every system I design starts with understanding the people
            who will use it and the business problems it needs to solve. I
            architect systems that are not just technically sound, but
            maintainable, scalable, and cost-effective over the long term.
          </Text>
        </div>
        {/*<div
          className="intro-photo"
          role="img"
          aria-label="Professional photo placeholder"
        >
          <div className="photo-placeholder">
            <Text size="sm" variant="muted">
              Professional Photo
              <br />
              Coming Soon
            </Text>
          </div>
        </div>*/}
      </div>
    </Card>
  )
}
